<template>
    <span>{{ amount | formatCurrency(currency) }}</span>
</template>

<script>
  export default {
    name: 'TMoney',
    props: {
      amount: {
        type: String,
        required: true,
      },
      currency: {
        type: String,
        required: true,
      },
      locale: {
        type: String,
        required: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
